import React from "react";
import "./ProjectCard.css";
import MoreIcon from "../icons/MoreIcon";
import ExportIcon from "../icons/ExportIcon";
import EditIcon from "../icons/EditIcon";
import TrashIcon from "../icons/TrashIcon";
import Dropdown from "../ui/Dropdown";
import Badge from "../ui/badges/Badge";
import { Project } from "../../types/project";
import { DropdownItem } from "../../types/dropdown";

interface ProjectCardProps {
  project: Project;
  onClick: () => void;
  variant?: "green" | "blue" | "purple" | "orange";
  onExport?: (project: Project) => void;
  onRename?: (project: Project) => void;
  onDelete?: (project: Project) => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  onClick,
  variant = "green",
  onExport,
  onRename,
  onDelete,
}) => {
  const dropdownItems: DropdownItem[] = [
    ...(project.has_result
      ? [
        {
          id: "export",
          label: "Export",
          icon: <ExportIcon size={18} />,
          onClick: () => onExport?.(project),
        },
      ]
      : []),
    {
      id: "rename",
      label: "Rename",
      icon: <EditIcon size={18} color="#45484f" />,
      onClick: () => onRename?.(project),
    },
    {
      id: "delete",
      label: "Delete",
      icon: <TrashIcon size={18} />,
      onClick: () => onDelete?.(project),
      variant: "danger",
    },
  ];

  const dropdownTrigger = (
    <button className="more-button" aria-label="More options">
      <MoreIcon size={16} />
    </button>
  );

  const projectTag = () => {
    if (project.mode === "chat")
      return "Strategy Session";

    return project?.metadata?.project_type || "Strategy Project";
  };

  const isNew = project.metadata?.is_new || false;

  return (
    <div
      className={`project-card project-card--${variant} ${isNew ? "project-card--new" : ""
        }`}
      onClick={onClick}
    >
      {/* Header with title and menu */}
      <div className="project-card-header">
        <h3 className="project-card-title">{project.name}</h3>
        <div onClick={(e) => e.stopPropagation()}>
          <Dropdown trigger={dropdownTrigger} items={dropdownItems} />
        </div>
      </div>

      {/* Badge */}
      <div className="badge-wrapper">
        <Badge
          value={projectTag()}
          className="badge-neutral"
        />
      </div>

      {/* Footer */}
      <small className="project-updated">
        Last Updated {new Date(project.updated_at).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })} at {new Date(project.updated_at).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </small>
    </div>
  );
};

export default ProjectCard;